import React, { useEffect, useState, useRef } from 'react';
import { useNavigate } from "react-router-dom";
import { useSearchParams } from 'react-router-dom';
import { ToolbarForm } from '../toolbar-form/toolbar-form'
import { CRMABillFormDetails } from './CRMABillFormDetails';
import { TextArea } from 'devextreme-react/text-area';
import ValidationGroup from 'devextreme-react/validation-group';
import GetFetch from '../../hooks/GetFetch';
import GetFetchZip from '../../hooks/GetFetchZip';
import PutPostPatchFetch from '../../hooks/PutPostPatchFetch';
// import BaseNotification from '../BaseNotification/BaseNotification';
import { TimelineComponent, ItemsDirective, ItemDirective } from '@syncfusion/ej2-react-layouts';
import * as signalR from '@microsoft/signalr';
import { useAuth } from '../../hooks/useAuth';
import { baseUrl } from "../../util/Endpoint";
import './CRMABillForm.scss';
import { Button, List } from 'devextreme-react';
import dayjs from 'dayjs';
import { GroupItem } from 'devextreme-react/cjs/form';
import { esES } from '@mui/x-data-grid';

/** @typedef {import('../../types/crmaBill').CRMABillData} CRMABillData */

/**
 * @param {CRMABillData} data 
 * @param {boolean} isLoading 
 * @param {boolean} isEditing 
 * @param {string} fileExtensions
 * @param {string} postPath
 * @param {string} backPath
 */

export const CRMABillForm = ({ data, fileExtensions, postPath, backPath, isEditing, isLoading = false }) => {
    const { user } = useAuth();
    const navigate = useNavigate();
    const navigateBack = () => navigate(backPath);
    const [searchParams] = useSearchParams();
    const [billId, setBillId] = useState(searchParams.get("id"));
    const BILL_ID = billId;
    const billEndpoint = `/v1/CRMABill/GetBillById/{crmaBillId}/${BILL_ID}`;
    const [editing, setEditing] = useState(isEditing);
    const [formInfo, setFormInfo] = useState(data);
    const [connection, setConnection] = useState(null);
    const [messages, setMessages] = useState([]);
    const [uploadStatus, setUploadStatus] = useState([]);
    const [highlightedKey, setHighlightedKey] = useState(null);
    const [completed, setCompleted] = useState(false);
    const [messageInput, setMessageInput] = useState('');
    const [notification, setNotification] = useState({
        message: '',
        type: undefined,
        visible: false
    });
    const isNew = billId ? false : data?.Id === 0;
    const dataRef = useRef(null);
    const listRef = useRef(null);
    
    const getAccessToken = () => {
        // Replace 'userToken' with the actual key you use in local storage
        const token = localStorage.getItem('JWT_TOKEN');
        return user ? token : null;
    };

    // useEffect(() => {
    //     loadData();
    // }, [BILL_ID]);

    const loadData = async () => {
        if (isNew)
            setFormInfo(data);
        // else
        // {
        //     // setIsLoading(true);
        //     const serverData = await GetFetch(billEndpoint);
        //     console.log(daserverDatata)
        //     const { Success, Message, Errors } = serverData;
        //     setError(Success === false);
        //     if (Success) {
        //         setData(Message);
        //         setFormInfo(Message);
        //     }
        //     // setIsLoading(false);
        // }
    };

    useEffect(() => {
        setFormInfo(data);
    }, [data]);

    // useEffect(() => {
    //     fetchUploadStatus();
    // }, [data]);

    useEffect(() => {
        // 1. Build the connection instance
        const connection = new signalR.HubConnectionBuilder()
        .withUrl(baseUrl() + `/notifyhub`, { 
            // accessTokenFactory: () => getAccessToken(),
            withCredentials: false 
            })
        .withAutomaticReconnect() // Handles unexpected drops gracefully
        .build();

        // 2. Register your event listeners
        connection.on('ReceiveMessage', (message) => {
            if (message.id === formInfo.Id) {
                console.log(message);
                setMessages(prevMessages => [...prevMessages, { id: prevMessages.length + 1, text: message.statusDomain.name + "\n" + message.statusDomain.message }]);
                setHighlightedKey(message.statusDomain.id);
                const isComplete = String(message.statusDomain.name).includes('COMPLETE');
                setCompleted(isComplete);
                if (isComplete) setHighlightedKey(null);
            }
        });

        // 3. Start the connection
        connection.start()
        .then(() => console.log('SignalR Connected!'))
        .catch((err) => console.error('SignalR Connection Error: ', err));

        // 4. CLEANUP: This runs when the component closes (unmounts)
        return () => {
        if (connection) {
            connection.stop()
            .then(() => console.log('SignalR Connection Gracefully Closed'))
            .catch((err) => console.error('SignalR Stop Error: ', err));
        }};
    }, []); // Empty dependency array ensures this runs once on mount/unmount

    const fetchUploadStatus = async () => {

        const statusList = await GetFetch('/v1/CRMABill/GetUploadStatus')

        if (statusList.Success === true) {
            // let allStatusItems = statusList.Message
            //     .map(s => {id: s.Id; name: s.Name; dotCss: s.DotCss; cssClass: {s.CssClass === '' ? 'line-notstarted':s.CssClass} ; message: s.Message });
            setUploadStatus(statusList.Message)
        }
        else {
            setError(true)
        }
    }

    const itemRender = (item) => {
        const isHighlighted = item.id === highlightedKey;
        return (
            <div className={isHighlighted ? 'highlighted-item' : ''}>
                {item.text}
            </div>
        );
    };
    const longText = "Japan is a sovereign island nation in East Asia. Located in the Pacific Ocean, it lies off the eastern coast of the Asian mainland and stretches from the Sea of Okhotsk in the north to the East China Sea and China in the southwest. The Greater Tokyo Area is the most populous metropolitan area in the world.";

    const handleEditClick = (e) => {
        if (editing === false && formInfo) {
            dataRef.current = formInfo;
        } else {
            dataRef.current = undefined;
        }
        setEditing(!editing);
    };

    const onSaveClick = async ({ validationGroup }) => {
        var formValid = validationGroup.validate().isValid;

        if (formValid === false)
            return;

        if (formValid === true) {
            const formData = new FormData();
            const fileArray = formInfo.UploadFiles;
            setEditing(false);
            // setMessages(prevMessages => [...prevMessages, { id: prevMessages.length +1, text: 'Upload Saved ' + dayjs(new Date()).format('MM/DD/YYYY hh:mm A') }]);
            formInfo.UploadFiles.forEach((file) => {
                formData.append('Files', file);
            });

            let result;
            if (isNew) {
                // result = await PutPostPatchFetch(`${postPath}` + '09/2025&billPeriod=09/2025', 'POST', formData, 'multipart/form-data'); 
                const testBillDate = formInfo.BillDate === undefined ? formData.BillDate : formInfo.BillDate;
                const testBillPeriod = formInfo.BillPeriod === undefined ? dayjs(formData.BillPeriod).format('MM-YYYY') : dayjs(formInfo.BillPeriod).format('MM-YYYY');
                result = await PutPostPatchFetch(`/v1/CRMA/UploadCRMABillData?billDate=${testBillDate}&billPeriod=${testBillPeriod}`,
                    'POST', formData, 'multipart/form-data');
            }

            if (result?.Success) {
                formInfo.Id = result?.Message?.Id;
                setNotification({
                    message: 'CRMA Bill Data Successfully Saved.',
                    type: 'success',
                    visible: true
                });
            };

            if (result?.Errors.length > 0) {
                setNotification({
                    message: result?.Errors[0].Message ?? 'CRMA Bill Data Not Saved.',
                    type: 'error',
                    visible: true
                });
            };
        }
    };

    const onBackClick = () => {
        navigateBack();
    };

    const onCancelClick = () => {
        navigateBack();
    };

    const onDownloadClick = async (e) => {
        let result;
        const testBillDate = formInfo.BillDate === undefined ? formData.BillDate : formInfo.BillDate;
        const testBillPeriod = formInfo.BillPeriod === undefined ? formData.BillPeriod : formInfo.BillPeriod;
        result = await GetFetchZip(`/v1/CRMA/DownloadCRMABillFiles?billPeriod=${testBillPeriod}`);

        if (result?.Success) {
            // formInfo.Id = result?.Message.Id;
            setNotification({
                message: 'CRMA Bill Data Successfully Downloaded.',
                type: 'success',
                visible: true
            });
        };

        if (result?.Errors.length > 0) {
            setNotification({
                message: result?.Errors[0].Message ?? 'CRMA Bill Data Not Downloaded.',
                type: 'error',
                visible: true
            });
        };
    };

    const updateField = (field, value) => {
        if (!formInfo) return;
        formInfo[field] = value;
    };

    const updateObject = (item, key, field, value) => {
        if (!formInfo) return;
        formInfo[item][key] = { ...formInfo[item][key], [field]: value };
    };


    return (
        <div className='grid-container'>
            <ValidationGroup>
                <ToolbarForm toggleEditing={handleEditClick}
                    onSaveClick={onSaveClick}
                    editing={editing}
                    onBackClick={onBackClick}
                    onCancelClick={onCancelClick}
                // width="500px"
                />
                <CRMABillFormDetails
                    // loading={isLoading}
                    // hasData={!formInfo}
                    data={formInfo}
                    editing={editing}
                    fileExtensions={fileExtensions}
                    updateField={updateField}
                    updateObject={updateObject}
                />
            </ValidationGroup>
            <div className='right-aligned-item'>
                <div className='default-timeline-section'>
                    <List length='50%'
                        focusStateEnabled={false}
                        itemRender={itemRender}
                        dataSource={messages}
                        keyExpr="id"
                        repaintChangesOnly={true}
                        selectionMode="none"
                        noDataText='Not Started'
                        ref={listRef} >
                    </List>
                    {/*                     <TimelineComponent align='Before'>
                        <ItemsDirective>
                            {uploadStatus.map((item) => {
                                return <ItemDirective key={item.Id} content={item.Name} oppositeContent={item.Message} dotCss={item.DotCss} cssClass={item.CssClass === '' ? 'line-notstarted' : item.CssClass} />
                            })}
                        </ItemsDirective>
                    </TimelineComponent> */}
                    <Button style={{ width: '50%' }} text='Download' onClick={onDownloadClick} />
                </div>
            </div>
{/*             <BaseNotification
                message={notification.message}
                ref={useRef(null)}
                setter={() => setNotification(() => (
                    {
                        isVisible: false,
                        message: '',
                        type: undefined
                    }
                ))}
                type={notification.type}
                visible={notification.visible}
            /> */}
        </div>
    );
};